<script>
export default {
  name: 'MontoDispersion',
  components: {},
  methods: {
    sendDispersion() {
      setTimeout(() => this.$router.push({ name: 'confirmation' }), 1000)
    },
  },
}
</script>

<template>
  <b-container
    class="container"
    fluid
  >
    <b-row class="justify-content-md-center">
      <b-col
        sm="8"
        lg="4"
      >
        <p class="text">{{ $t('WIDGETS.RT_DISPERSION.GET_INTO') }} <b>{{ $t('WIDGETS.RT_DISPERSION.AMOUNT') }}</b></p>
      </b-col>
    </b-row>

    <b-row class="justify-content-md-center">
      <b-col
        sm="8"
        lg="4"
      >
        <b-input-group size="lg">
          <b-form-input
            class="input"
            type="number"
            placeholder="$0"
          />
        </b-input-group>
      </b-col>
    </b-row>

    <br>

    <b-row class="justify-content-md-center">
      <b-col
        sm="8"
        lg="4"
      >
        <BaseButton
          @click="sendDispersion()"
        >
          {{ $t('WIDGETS.COMMON.UNDERSTOOD') }}
        </BaseButton>
      </b-col>
    </b-row>

  </b-container>
</template>


<style scoped lang="scss">
.input {
  height: 70px;
  text-align: center;
  border: 2px solid #4fb296;
  border-radius: 64px;
}

.text {
  font-size: 2rem;
  line-height: 1;
}

.container {
  // background-color: red;
}
</style>
